import { Link01Icon } from '@langchain/untitled-ui-icons';

import { useMemo, useState } from 'react';

import { IconButton } from '@/design-system';
import { appHubIndexPath } from '@/utils/constants';

const CopyPublicLinkButton = ({
  owner,
  repo,
  commit,
}: {
  owner: string | null;
  repo: string;
  commit?: string;
}) => {
  const shareLink = useMemo(
    () =>
      `${window.location.origin}/${appHubIndexPath}/${owner}/${repo}${
        commit ? `/${commit}` : ''
      }`,
    [owner, repo, commit]
  );

  const [tooltipTitle, setTooltipTitle] = useState(`Public Link: ${shareLink}`);

  const handleCopyClick = async () => {
    try {
      await navigator.clipboard.writeText(shareLink);
      setTooltipTitle('Copied!');
    } catch (e: unknown) {
      const errorMessage = e instanceof Error ? e.message : 'Unknown error';
      setTooltipTitle(`Failed to copy: ${errorMessage}`);
    } finally {
      setTimeout(() => setTooltipTitle(`Public Link: ${shareLink}`), 3000);
    }
  };

  if (!owner) {
    return null;
  }

  return (
    <IconButton
      onClick={handleCopyClick}
      color="secondary"
      variant="outlined"
      size="md"
      icon={Link01Icon}
      label={tooltipTitle}
    />
  );
};

export default CopyPublicLinkButton;
